
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type collapsibleVehicleWidgetRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function collapsibleVehicleWidgetRT(): TemplateResult<collapsibleVehicleWidgetRTRootProps> {
    function repeatSelects1(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '11021'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '11024'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3324'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3526'
                    }, entry.hitCount) : null);
                }
                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '39'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                        'aria-label': this.title,
                        'key': '2586'
                    },
                    !this.hideNullOption ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'onClick': () => this.onChange('')
                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                    this.loading ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                ]) : null);
            }, { count: undefined })];
    }
    function repeatSelects2(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '11021'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '11024'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4() {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3324'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3526'
                    }, entry.hitCount) : null);
                }
                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                    'key': '39'
                }, _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                            return _createElement('div', { 'className': 'cm_filterInput' });
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                        'aria-label': this.title,
                        'key': '2586'
                    },
                    !this.hideNullOption ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'onClick': () => this.onChange('')
                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                    this.loading ? _createElement('div', {
                        'className': 'option',
                        'key': 'null-option',
                        'disabled': true
                    }, _translate(`select_loading`)) : null,
                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                ]) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__home cm_vehicle-widget__header cm_vehicle-widget__collapsible' }, this.template === 'locked' ? _createElement('div', {
        'className': 'cmTemplate_locked',
        'key': '116'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_header' }, _createElement('span', {
        'className': 'cm_vehicle-widget_header-label',
        'onClick': this.changeVehicle
    }, '\n        ', this.vehicleString, '\n      '), [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle down',
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '3690'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))], _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_button cm_button__primary',
        'onClick': this.changeVehicle,
        'role': 'button',
        'tabIndex': '0'
    }, '\n          ', _translate(`ymm_bar_change`), '\n        '), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_button cm_button__secondary',
        'onClick': this.discardVehicle,
        'role': 'button',
        'tabIndex': '0'
    }, '\n          ', _translate(`ymm_bar_discard`), '\n        ')))) : null, this.template === 'active' ? _createElement('div', {
        'className': 'cmTemplate_active',
        'key': '1137'
    }, !this.withCollapsing ? _createElement('div', {
        'className': 'cm_vehicle-widget_dropdowns',
        'key': '1218'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, 'SHOP PARTS BY VEHICLE', _createElement('div', { 'className': 'cm_vehicle-widget_subtitle' }, 'Enter your vehicle to see only products built to fit across the entire site.')), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects1.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_button cm_button__primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '15',
            'height': '15',
            'viewBox': '0 0 60 52',
            'fill': 'none',
            'className': 'icon-vehicle',
            'key': '75750'
        }, _createElement('path', { 'd': 'M10.1743 47.9394C10.1719 44.5837 10.1961 44.6367 8.21742 43.6339C5.17797 42.0934 5.32812 42.7299 5.33055 31.2959C5.33539 19.4303 5.53156 20.1053 2.06586 20.1053C0 20.1053 0 20.1053 0 18.4347C0 16.1349 0.162266 16.0071 3.06367 16.0071C6.21695 16.0071 6.02805 16.2458 7.84203 10.0213C9.84977 3.13871 10.5812 1.44639 11.8817 0.679783C13.3155 -0.166377 45.1583 -0.250752 47.2702 0.585766C49.0405 1.28728 49.7598 2.83014 51.4794 9.61871C53.1795 16.3374 52.9107 16.0071 56.6864 16.0071C59.5781 16.0071 59.5781 16.0071 59.5781 18.0562C59.5781 20.1053 59.5781 20.1053 57.3791 20.1053C53.9497 20.1053 54.25 19.0904 54.25 30.6859C54.25 42.3032 54.25 42.3008 51.7966 43.2434C48.9485 44.3354 49.1641 43.9401 49.1641 48.0576C49.1641 51.6857 49.1641 51.6857 47.4688 51.6857C45.7734 51.6857 45.7734 51.6857 45.7734 48.3806C45.7734 43.4169 47.7545 43.9714 29.9925 43.9714C20.2856 43.9714 14.8824 44.0582 14.553 44.2173C14.0735 44.4535 14.0469 44.6512 14.0469 48.0744C14.0469 51.6857 14.0469 51.6857 12.2305 51.6857C10.5424 51.6857 10.4068 51.6471 10.2954 51.1433C10.2324 50.8443 10.1767 49.4027 10.1743 47.9394ZM22.7656 37.137C22.7656 34.4587 22.4532 34.5696 29.9949 34.5696H36.5703C36.5703 39.5309 36.2337 39.391 43.5768 39.391C50.9974 39.391 50.6172 39.5526 50.6172 36.4017C50.6172 33.3329 50.438 33.1232 47.8345 33.1232C45.7734 33.1232 45.7734 33.1232 45.7734 31.0741C45.7734 29.025 45.7734 29.025 47.6504 29.0274C50.3145 29.0298 50.6172 28.7405 50.6172 26.1707C50.6172 23.8853 50.2442 23.2465 48.9025 23.2272C48.4472 23.22 39.5202 23.2224 29.0625 23.232C6.90234 23.2513 8.97062 22.9741 8.94641 25.9296C8.92703 28.497 9.36055 28.9526 12.0488 29.1696C14.0469 29.3311 14.0469 29.3311 14.0469 31.2259C14.0469 33.1232 14.0469 33.1232 12.107 33.1232C9.30727 33.1232 9.10383 33.2992 8.99727 35.828C8.95125 36.9417 9.03359 38.1977 9.17891 38.622C9.44531 39.391 9.44531 39.391 15.6453 39.391C22.9109 39.391 22.7656 39.4368 22.7656 37.137ZM48.8153 18.0659C49.5007 17.5524 46.9166 6.71862 45.8073 5.46023C44.8798 4.40434 15.253 4.17532 13.9887 5.21434C13.422 5.67961 13.0805 6.59327 11.6977 11.3062C10.4528 15.5563 10.1137 17.0341 10.2445 17.6343C10.4141 18.4178 10.4141 18.4178 29.3798 18.4178C45.6427 18.4178 48.4109 18.3672 48.8153 18.0659Z' }))], ' Add Your Vehicle ', [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '6',
            'viewBox': '0 0 25 18',
            'fill': 'none',
            'className': 'icon-go',
            'key': '99770'
        }, _createElement('path', {
            'd': 'M13.9514 13.138C15.4268 11.6095 15.7542 11.6923 8.27922 11.6923C2.10177 11.6923 2.10177 11.6923 1.51432 11.3574C-0.505589 10.204 -0.504363 7.57564 1.51554 6.42468C2.10422 6.08974 2.10422 6.08974 8.47545 6.08974C11.9793 6.08974 14.8994 6.0459 14.9644 5.99353C15.0343 5.93628 14.659 5.34192 14.0471 4.53929C12.4723 2.47731 12.3963 1.6759 13.6632 0.517628C14.2298 0 14.2298 0 15.3323 0C16.4361 0 16.4361 0 17.6772 1.1266C18.3604 1.74654 19.1612 2.58205 19.4568 2.98397C20.1595 3.93763 21.5846 5.54167 21.9108 5.74628C22.3585 6.02641 24.6592 8.64378 24.6592 8.87276C24.6592 9.12244 22.3229 11.7812 21.7955 12.1308C21.6042 12.2587 20.7923 13.1648 19.9915 14.1465C19.1906 15.1269 18.0636 16.3461 17.4871 16.8564C16.4386 17.7821 16.4386 17.7821 15.2146 17.7821C13.9894 17.7821 13.9894 17.7821 13.4216 17.044C12.3816 15.6933 12.5275 14.6129 13.9514 13.138Z',
            'fill': 'white'
        }))]), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_button cm_button__secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button',
        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
    }, '\n    Reset ', [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '11',
            'height': '9',
            'viewBox': '0 0 33 28',
            'fill': 'none',
            'key': '112800'
        }, _createElement('path', {
            'd': 'M18.7014 23.0298C24.1452 22.5056 27.565 19.3354 27.8628 14.5368C28.3877 6.08095 18.4992 1.6033 12.5852 7.61894C11.0204 9.21023 9.67406 11.793 10.0562 12.4671C10.2076 12.7361 10.2262 12.7274 11.2835 11.9342C13.1498 10.5338 14.8572 10.9192 15.4876 12.8823C15.8511 14.0126 15.3709 14.7314 12.0069 18.0874C7.6688 22.4164 7.8326 22.43 2.85172 17.3092C0.0560296 14.4352 -0.404335 13.5565 0.281869 12.3965C1.20136 10.8424 2.66559 10.654 4.21669 11.8896C5.12377 12.6134 5.47121 12.5663 5.47121 11.7198C5.47121 7.40082 9.91231 2.2998 15.16 0.59202C22.0667 -1.65486 30.1311 2.73356 31.9031 9.70347C32.1203 10.5561 32.3759 11.5426 32.4714 11.8983C32.6836 12.6803 32.7072 15.2581 32.5062 15.6683C32.428 15.8257 32.32 16.3462 32.2642 16.8258C31.7219 21.4931 27.5687 25.9385 22.4092 27.3749C21.4686 27.6364 20.8308 27.7293 19.7723 27.7591C18.3763 27.7975 18.3763 27.7975 17.6914 27.2423C16.17 26.0079 16.8401 23.2083 18.7014 23.0298Z',
            'fill': '#C22735'
        }))])))) : null, this.withCollapsing ? _createElement('div', {
        'className': 'cm_vehicle-widget_header',
        'onClick': this.toggleCollapsed,
        'key': '12395'
    }, _createElement('span', { 'className': 'cm_vehicle-widget_header-label' }, !this.isVehicleSelected ? [
        'SHOP PARTS BY VEHICLE',
        _createElement('div', {
            'className': 'cm_vehicle-widget_subtitle',
            'key': '125561'
        }, 'Enter your vehicle to see only products built to fit across the entire site.')
    ] : null, this.isVehicleSelected ? [this.vehicleString] : null), !this.collapsed ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle up',
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '128620'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null, this.collapsed ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-angle down',
            'height': '20px',
            'role': 'img',
            'viewBox': '39 30 565 565',
            'aria-hidden': 'true',
            'key': '131820'
        }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null) : null, this.withCollapsing ? _createElement('div', {
        'className': 'cm_collapsible-elem',
        'key': '13512'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects2.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_button cm_button__primary',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '15',
            'height': '15',
            'viewBox': '0 0 60 52',
            'fill': 'none',
            'className': 'icon-vehicle',
            'key': '197170'
        }, _createElement('path', { 'd': 'M10.1743 47.9394C10.1719 44.5837 10.1961 44.6367 8.21742 43.6339C5.17797 42.0934 5.32812 42.7299 5.33055 31.2959C5.33539 19.4303 5.53156 20.1053 2.06586 20.1053C0 20.1053 0 20.1053 0 18.4347C0 16.1349 0.162266 16.0071 3.06367 16.0071C6.21695 16.0071 6.02805 16.2458 7.84203 10.0213C9.84977 3.13871 10.5812 1.44639 11.8817 0.679783C13.3155 -0.166377 45.1583 -0.250752 47.2702 0.585766C49.0405 1.28728 49.7598 2.83014 51.4794 9.61871C53.1795 16.3374 52.9107 16.0071 56.6864 16.0071C59.5781 16.0071 59.5781 16.0071 59.5781 18.0562C59.5781 20.1053 59.5781 20.1053 57.3791 20.1053C53.9497 20.1053 54.25 19.0904 54.25 30.6859C54.25 42.3032 54.25 42.3008 51.7966 43.2434C48.9485 44.3354 49.1641 43.9401 49.1641 48.0576C49.1641 51.6857 49.1641 51.6857 47.4688 51.6857C45.7734 51.6857 45.7734 51.6857 45.7734 48.3806C45.7734 43.4169 47.7545 43.9714 29.9925 43.9714C20.2856 43.9714 14.8824 44.0582 14.553 44.2173C14.0735 44.4535 14.0469 44.6512 14.0469 48.0744C14.0469 51.6857 14.0469 51.6857 12.2305 51.6857C10.5424 51.6857 10.4068 51.6471 10.2954 51.1433C10.2324 50.8443 10.1767 49.4027 10.1743 47.9394ZM22.7656 37.137C22.7656 34.4587 22.4532 34.5696 29.9949 34.5696H36.5703C36.5703 39.5309 36.2337 39.391 43.5768 39.391C50.9974 39.391 50.6172 39.5526 50.6172 36.4017C50.6172 33.3329 50.438 33.1232 47.8345 33.1232C45.7734 33.1232 45.7734 33.1232 45.7734 31.0741C45.7734 29.025 45.7734 29.025 47.6504 29.0274C50.3145 29.0298 50.6172 28.7405 50.6172 26.1707C50.6172 23.8853 50.2442 23.2465 48.9025 23.2272C48.4472 23.22 39.5202 23.2224 29.0625 23.232C6.90234 23.2513 8.97062 22.9741 8.94641 25.9296C8.92703 28.497 9.36055 28.9526 12.0488 29.1696C14.0469 29.3311 14.0469 29.3311 14.0469 31.2259C14.0469 33.1232 14.0469 33.1232 12.107 33.1232C9.30727 33.1232 9.10383 33.2992 8.99727 35.828C8.95125 36.9417 9.03359 38.1977 9.17891 38.622C9.44531 39.391 9.44531 39.391 15.6453 39.391C22.9109 39.391 22.7656 39.4368 22.7656 37.137ZM48.8153 18.0659C49.5007 17.5524 46.9166 6.71862 45.8073 5.46023C44.8798 4.40434 15.253 4.17532 13.9887 5.21434C13.422 5.67961 13.0805 6.59327 11.6977 11.3062C10.4528 15.5563 10.1137 17.0341 10.2445 17.6343C10.4141 18.4178 10.4141 18.4178 29.3798 18.4178C45.6427 18.4178 48.4109 18.3672 48.8153 18.0659Z' }))], ' Add Your Vehicle ', [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '8',
            'height': '6',
            'viewBox': '0 0 25 18',
            'fill': 'none',
            'className': 'icon-go',
            'key': '221190'
        }, _createElement('path', {
            'd': 'M13.9514 13.138C15.4268 11.6095 15.7542 11.6923 8.27922 11.6923C2.10177 11.6923 2.10177 11.6923 1.51432 11.3574C-0.505589 10.204 -0.504363 7.57564 1.51554 6.42468C2.10422 6.08974 2.10422 6.08974 8.47545 6.08974C11.9793 6.08974 14.8994 6.0459 14.9644 5.99353C15.0343 5.93628 14.659 5.34192 14.0471 4.53929C12.4723 2.47731 12.3963 1.6759 13.6632 0.517628C14.2298 0 14.2298 0 15.3323 0C16.4361 0 16.4361 0 17.6772 1.1266C18.3604 1.74654 19.1612 2.58205 19.4568 2.98397C20.1595 3.93763 21.5846 5.54167 21.9108 5.74628C22.3585 6.02641 24.6592 8.64378 24.6592 8.87276C24.6592 9.12244 22.3229 11.7812 21.7955 12.1308C21.6042 12.2587 20.7923 13.1648 19.9915 14.1465C19.1906 15.1269 18.0636 16.3461 17.4871 16.8564C16.4386 17.7821 16.4386 17.7821 15.2146 17.7821C13.9894 17.7821 13.9894 17.7821 13.4216 17.044C12.3816 15.6933 12.5275 14.6129 13.9514 13.138Z',
            'fill': 'white'
        }))]), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_button cm_button__secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button',
        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
    }, '\n    Reset ', [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '11',
            'height': '9',
            'viewBox': '0 0 33 28',
            'fill': 'none',
            'key': '234220'
        }, _createElement('path', {
            'd': 'M18.7014 23.0298C24.1452 22.5056 27.565 19.3354 27.8628 14.5368C28.3877 6.08095 18.4992 1.6033 12.5852 7.61894C11.0204 9.21023 9.67406 11.793 10.0562 12.4671C10.2076 12.7361 10.2262 12.7274 11.2835 11.9342C13.1498 10.5338 14.8572 10.9192 15.4876 12.8823C15.8511 14.0126 15.3709 14.7314 12.0069 18.0874C7.6688 22.4164 7.8326 22.43 2.85172 17.3092C0.0560296 14.4352 -0.404335 13.5565 0.281869 12.3965C1.20136 10.8424 2.66559 10.654 4.21669 11.8896C5.12377 12.6134 5.47121 12.5663 5.47121 11.7198C5.47121 7.40082 9.91231 2.2998 15.16 0.59202C22.0667 -1.65486 30.1311 2.73356 31.9031 9.70347C32.1203 10.5561 32.3759 11.5426 32.4714 11.8983C32.6836 12.6803 32.7072 15.2581 32.5062 15.6683C32.428 15.8257 32.32 16.3462 32.2642 16.8258C31.7219 21.4931 27.5687 25.9385 22.4092 27.3749C21.4686 27.6364 20.8308 27.7293 19.7723 27.7591C18.3763 27.7975 18.3763 27.7975 17.6914 27.2423C16.17 26.0079 16.8401 23.2083 18.7014 23.0298Z',
            'fill': '#C22735'
        }))]))))) : null) : null);
}
        export const componentNames = ["cm:filterInput","cm:filterInput"]